import { CoupleFileType, FileType } from '@/api/Files/types';

export const unpackCoupleFileType = (coupleFileType: CoupleFileType): [FileType, FileType] => {
  if (coupleFileType === 'rasters') {
    return ['rastrTAB', 'rastrJPG'] as unknown as [FileType, FileType];
  } else {
    return ['kptMIF', 'kptXML'] as unknown as [FileType, FileType];
  }
};
